module.exports = __webpack_public_path__ + "static/grafika1@2x-332b9f1ea6df2b5b3807c9123bd07dc9.png";